var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg3DIcon = function Svg3DIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.72727 4.88451C8.9815 4.87137 9.23882 4.86365 9.5 4.86365C14.1943 4.86365 18 6.93919 18 9.50001C18 12.0608 14.1943 14.1364 9.5 14.1364C4.80568 14.1364 1 12.0608 1 9.50001C1.03571 8.96842 1.19377 8.45228 1.46185 7.99185C1.72993 7.53142 2.10078 7.13916 2.54545 6.84569",
    stroke: "currentColor",
    strokeWidth: 1.54545,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1155 10.2727C14.1286 10.0185 14.1364 9.76118 14.1364 9.5C14.1364 4.80568 12.0608 1 9.50001 1C6.93919 1 4.86365 4.80568 4.86365 9.5C4.86365 14.1943 6.93919 18 9.50001 18C10.0316 17.9643 10.5477 17.8062 11.0082 17.5381C11.4686 17.2701 11.8609 16.8992 12.1543 16.4545",
    stroke: "currentColor",
    strokeWidth: 1.54545,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50002 10.2727C9.92679 10.2727 10.2727 9.92679 10.2727 9.50002C10.2727 9.07326 9.92679 8.72729 9.50002 8.72729C9.07326 8.72729 8.72729 9.07326 8.72729 9.50002C8.72729 9.92679 9.07326 10.2727 9.50002 10.2727Z",
    stroke: "currentColor",
    strokeWidth: 1.54545,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default Svg3DIcon;